/**
 * Wishlist Count
 */

import * as utils from "@sharedJS/utils";
import OcmMessenger from "ocm_mercurius_messenger";
import { messengerPublicationTypes } from "@ocm/services/services.constants.js";

function init() {
	OcmMessenger.subscribe(messengerPublicationTypes.REMOVED_FROM_WISHLIST, onRemove); // published by wishlist
	OcmMessenger.subscribe(messengerPublicationTypes.UPDATE_MULTIPLE_WISHLIST, onUpdate); // published by plp, pdp and cart

	// make sure wishlist count is always up to date (browser back / cache-control)
	requestWishlistCount();
}

async function requestWishlistCount() {
	// does only exist if user's auth level >= 500
	if (!document.querySelector(".js-wishlistCounter-badge")) return;

	const requestUrl = utils.getUrl("/rest/wishlist/count/");
	const requestParams = new URLSearchParams({ _: new Date().getTime() });
	const url = new URL(`${requestUrl}?${requestParams}`).href;

	try {
		const response = await fetch(url, { priority: "low" });
		if (!response.ok) throw new Error("Wishlist count request failed");
		const count = await response.json();
		if (Number.isInteger(count)) writeItemCount(count);
	} catch (error) {
		console.error(error);
	}
}

function onUpdate(payload) {
	writeItemCount(payload.data.sizeCodes.length);
}

function onRemove(payload) {
	writeItemCount(payload.data.count);
}

/** @param {number} count */
function writeItemCount(count) {
	const wishlistCounterBadges = document.querySelectorAll(".js-wishlistCounter-badge");
	if (wishlistCounterBadges.length === 0) return;
	[...wishlistCounterBadges].forEach((badge) => (badge.textContent = count));
	OcmMessenger.publish(messengerPublicationTypes.UPDATED_WISHLIST_COUNT, count);
}

export { init };
